'use client';

import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { PulseRadio } from 'src/components/PulseUI/PulseRadio';

interface ControlledRadioCardProps {
  name: string;
  value: string;
  label: string;
  description?: string;
  'data-testid'?: string;
}

const ControlledRadioCard: React.FC<ControlledRadioCardProps> = ({
  name,
  value,
  label,
  description,
  'data-testid': dataTestId,
}) => {
  const { control, watch } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const isSelected = watch(name) === value;
        return (
          <div
            className={`border rounded-xl hover:bg-neutral-50 hover:cursor-pointer ${
              isSelected ? 'border-sky-600' : 'border-neutral-200'
            }`}
            onClick={() => field.onChange(value)}
            data-testid={dataTestId}
          >
            <div className="flex gap-2 p-4">
              <PulseRadio
                label=""
                checked={watch(name) === value}
                onChange={() => field.onChange(value)}
                value={value}
              />
              <div className="flex flex-col gap-1">
                <h4 className="font-semibold text-primary leading-tight">
                  {label}
                </h4>
                {description && (
                  <p className="text-sm font-medium text-tertiary leading-tight">
                    {description}
                  </p>
                )}
              </div>
            </div>
          </div>
        );
      }}
    />
  );
};

export default ControlledRadioCard;
